import { render, staticRenderFns } from "./compose-patient.vue?vue&type=template&id=6ab9cfc4&scoped=true&"
import script from "./compose-patient.vue?vue&type=script&lang=ts&"
export * from "./compose-patient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab9cfc4",
  null
  
)

export default component.exports